import type { Language } from "@/lib/types";

/**
 * Supported locales. All of them ship full translations
 * (see lib/i18n/translations.ts); any locale added here without an
 * entry there falls back to English copy.
 */
export const LANGUAGES: Language[] = [
  { code: "en", name: "English", flag: "🇬🇧", short: "EN" },
  { code: "de", name: "Deutsch", flag: "🇩🇪", short: "DE" },
  { code: "es", name: "Español", flag: "🇪🇸", short: "ES" },
  { code: "fr", name: "Français", flag: "🇫🇷", short: "FR" },
  { code: "it", name: "Italiano", flag: "🇮🇹", short: "IT" },
  { code: "ja", name: "日本語", flag: "🇯🇵", short: "JP" },
  { code: "ru", name: "Русский", flag: "🇷🇺", short: "RU" },
  { code: "nl", name: "Nederlands", flag: "🇳🇱", short: "NL" },
  { code: "el", name: "Ελληνικά", flag: "🇬🇷", short: "EL" },
  { code: "pt", name: "Português", flag: "🇵🇹", short: "PT" },
];

export const DEFAULT_LOCALE = "en";
